import { render, staticRenderFns } from "./StudyResultsDrawerEditColumns.vue?vue&type=template&id=d968601a&scoped=true&"
import script from "./StudyResultsDrawerEditColumns.vue?vue&type=script&lang=js&"
export * from "./StudyResultsDrawerEditColumns.vue?vue&type=script&lang=js&"
import style0 from "./StudyResultsDrawerEditColumns.vue?vue&type=style&index=0&id=d968601a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d968601a",
  null
  
)

export default component.exports